module.exports = {"410527100":"城关镇","410527101":"东庄镇","410527102":"井店镇","410527103":"梁庄镇","410527104":"后河镇","410527105":"楚旺镇","410527106":"田氏镇","410527107":"二安镇","410527108":"亳城镇","410527109":"豆公镇","410527200":"张龙乡","410527201":"马上乡","410527202":"高堤乡","410527205":"六村乡","410527206":"中召乡","410527207":"宋村乡","410527209":"石盘屯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410527.json
// module id = 1694
// module chunks = 0